import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { consumePostLoginRedirect } from '../utils/post-login-redirect';

export function GoogleCallbackPage() {
  const [searchParams] = useSearchParams();
  const { handleGoogleCallback } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    const code = searchParams.get('code');
    if (!code) {
      setError('No authorization code received from Google');
      return;
    }

    handleGoogleCallback(code)
      .then(() => navigate(consumePostLoginRedirect(), { replace: true }))
      .catch((err) => {
        setError(err?.response?.data?.message || 'Authentication failed. Please try again.');
      });
  }, [searchParams, handleGoogleCallback, navigate]);

  if (error) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <h2>Authentication Error</h2>
          <p>{error}</p>
          <a href="/login">Back to Login</a>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <p>Completing sign in...</p>
    </div>
  );
}
